export default __webpack_public_path__ + "static/media/BITPAYz.f7b667e5.png";